import React from "react";
import {
  Box,
  Typography,
  Link,
  Grid,
  IconButton,
  Container,
} from "@mui/material";
import { Facebook, Twitter, LinkedIn, Instagram } from "@mui/icons-material"; // Social media icons

const Footer = () => {
  return (
    <Box
      sx={{
        backgroundColor: (theme) => theme.palette.container.main,
        color: "white",
        padding: 4,
        marginTop: "auto", // Ensures footer sticks to the bottom
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* Quick Links */}
          <Grid item xs={12} md={3}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: "bold" }}>
              Quick Links
            </Typography>
            <Link href="/" color="inherit" underline="hover" display="block">
              Home
            </Link>
            <Link
              href="/about"
              color="inherit"
              underline="hover"
              display="block"
            >
              About Us
            </Link>
            <Link
              href="/services"
              color="inherit"
              underline="hover"
              display="block"
            >
              Services
            </Link>
            <Link
              href="/contact"
              color="inherit"
              underline="hover"
              display="block"
            >
              Contact Us
            </Link>
          </Grid>

          {/* Legal Information */}
          <Grid item xs={12} md={3}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: "bold" }}>
              Legal
            </Typography>
            <Link
              href="/privacy-policy"
              color="inherit"
              underline="hover"
              display="block"
            >
              Privacy Policy
            </Link>
            <Link
              href="/cookies"
              color="inherit"
              underline="hover"
              display="block"
            >
              Cookie Policy
            </Link>
            <Link
              href="/terms"
              color="inherit"
              underline="hover"
              display="block"
            >
              Terms & Conditions
            </Link>
          </Grid>

          {/* Contact Information */}
          <Grid item xs={12} md={3}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: "bold" }}>
              Contact Us
            </Typography>
            <Typography variant="body1" paragraph>
              Email: info@yourwebsite.com
            </Typography>
            <Typography variant="body1" paragraph>
              Phone: +44 1234 567890
            </Typography>
            <Typography variant="body1" paragraph>
              Address: 123 Business Street, London, UK, AB1 2CD
            </Typography>
          </Grid>

          {/* Social Media Icons */}
          <Grid item xs={12} md={3}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: "bold" }}>
              Follow Us
            </Typography>
            <Box>
              <IconButton
                //href="https://facebook.com"
                target="_blank"
                rel="noopener"
                color="inherit"
              >
                <Facebook />
              </IconButton>
              <IconButton
                //href="https://twitter.com"
                target="_blank"
                rel="noopener"
                color="inherit"
              >
                <Twitter />
              </IconButton>
              <IconButton
                //href="https://linkedin.com"
                target="_blank"
                rel="noopener"
                color="inherit"
              >
                <LinkedIn />
              </IconButton>
              <IconButton
                //href="https://instagram.com"
                target="_blank"
                rel="noopener"
                color="inherit"
              >
                <Instagram />
              </IconButton>
            </Box>
          </Grid>
        </Grid>

        {/* Copyright Section */}
        <Box
          sx={{
            borderTop: "1px solid rgba(255, 255, 255, 0.1)",
            paddingTop: 2,
            marginTop: 4,
            textAlign: "center",
          }}
        >
          <Typography variant="body2">
            &copy; {new Date().getFullYear()} UK Company Incorportation. All
            rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
